// extracted by mini-css-extract-plugin
export default {"noParams":"ActionParameters_noParams__g0av4"};